const counties = [
    'ABERDEENSHIRE',
    'ANGUS',
    'KINCARDINESHIRE',
    'ANTRIM',
    'ARGYLL',
    'ARMAGH',
    'AVON',
    'AYRSHIRE ',
    'WIGTOWNSHIRE',
    'KIRKCUDBRIGHTSHIRE',
    'BEDFORDSHIRE',
    'BERKSHIRE',
    'BERWICKSHIRE',
    'ROXBURGHSHIRE',
    'EAST LOTHIAN',
    'BUCKINGHAMSHIRE',
    'CAMBRIDGESHIRE',
    'CHESHIRE',
    'CLEVELAND',
    'CLWYD',
    'CORNWALL',
    'COUNTY DURHAM',
    'CUMBRIA',
    'ISLE OF MAN',
    'DERBYSHIRE',
    'DEVON',
    'DORSET',
    'DOWN',
    'DUMFRIESSHIRE',
    'PEEBLESSHIRE',
    'SELKIRKSHIRE',
    'DUNBARTONSHIRE',
    'DURHAM',
    'DYFED',
    'EAST SUSSEX',
    'EAST YORKSHIRE',
    'HUMBERSIDE',
    'ESSEX',
    'FERMANAGH',
    'TYRONE',
    'FIFE',
    'GLOUCESTERSHIRE',
    'GREATER LONDON',
    'GREATER MANCHESTER',
    'GWENT',
    'GWYNEDD',
    'HAMPSHIRE',
    'ISLE OF WIGHT',
    'HEREFORDSHIRE',
    'WORCESTERSHIRE',
    'HERTFORDSHIRE',
    'INVERNESS-SHIRE',
    'BANFFSHIRE',
    'KENT',
    'LANARKSHIRE',
    'LANCASHIRE',
    'LEICESTERSHIRE',
    'LINCOLNSHIRE',
    'LONDONDERRY',
    'LOTHIAN',
    'MERSEYSIDE',
    'MID GLAMORGAN',
    'MIDDLESEX',
    'MIDLOTHIAN',
    'MORAYSHIRE',
    'NORFOLK',
    'NORTH YORKSHIRE',
    'NORTHAMPTONSHIRE',
    'NORTHUMBERLAND',
    'NOTTINGHAMSHIRE',
    'OXFORDSHIRE',
    'PERTHSHIRE',
    'CLACKMANNANSHIRE',
    'POWYS',
    'RENFREWSHIRE',
    'ROSS-SHIRE',
    'SUTHERLAND',
    'CAITHNESS',
    'LEWIS',
    'ORKNEY',
    'SHETLAND',
    'RUTLAND',
    'SHROPSHIRE',
    'SOMERSET',
    'SOUTH GLAMORGAN',
    'SOUTH YORKSHIRE',
    'STAFFORDSHIRE',
    'STIRLINGSHIRE',
    'SUFFOLK',
    'SURREY',
    'TYNE AND WEAR',
    'WARWICKSHIRE',
    'WEST GLAMORGAN',
    'WEST LOTHIAN',
    'WEST MIDLANDS',
    'WEST SUSSEX',
    'WEST YORKSHIRE',
    'WILTSHIRE',
]

export const checkCounties = (text: string) => {
    text = text.trim()
    let textFixed = fixCasing(text)
    let county = ''
    if (counties.some((county) => county == text.toUpperCase())) {
        county = textFixed
    }
    return county
}
export const capitaliseFirstLetter = (text: string) => {
    if (!text) return ''
    return text.charAt(0).toUpperCase() + text.slice(1)
}

export const fixCasing = (text: string) => {
    return capitaliseFirstLetter(text.toLowerCase())
}
